import { ComponentProps } from 'react';
import { Image } from 'react-datocms';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { BlogPostCard } from '@carbonify/ui';
import { formatDate } from '@carbonify/ui/utils/format';
import InlineRichText from 'components/RichContent/InlineRichText';
import useMarketingUrl from 'hooks/useMarketingUrl';
import useConfig from 'services/config';
import { ResponsiveImage } from 'services/graphql';

import AuthorBlock from './AuthorBlock';

interface BlogPostBlockRecord extends CdaStructuredTextRecord {
  image: ResponsiveImage;
  title: string;
  description?: string;
  slug: string;
  author?: ComponentProps<typeof AuthorBlock>;
  _publishedAt: string;
}

export default function BlogPostBlock({ title, description, image, slug, author, _publishedAt }: BlogPostBlockRecord) {
  const getUrl = useMarketingUrl();
  const { locale } = useConfig();

  return (
    <BlogPostCard
      title={title}
      description={description && <InlineRichText as={null}>{description}</InlineRichText>}
      href={getUrl(`blog/${slug}`)}
      compact
      image={
        image && (
          // eslint-disable-next-line jsx-a11y/alt-text
          <Image
            data={image.responsiveImage}
            objectFit="cover"
            objectPosition="center"
            style={{ height: '100%' }}
          />
        )
      }
      footer={
        author?.title && (
          <AuthorBlock
            {...author}
            subtitle={_publishedAt && formatDate(_publishedAt, locale)}
          />
        )
      }
    />
  );
}
